export type ProjectKey =
  | "joj2026"
  | "burnoutCheck"
  | "socabeg"
  | "khalilCollection"
  | "noppalJaay"
  | "magouGlow"
  | "sengeoMap"
  | "yoonExpress"
  | "rentyx";

export interface Project {
  id: number;
  key: ProjectKey;
  image: string;
  skills: string[];
  demoLink?: string;
  codeLink?: string;
}

export const projects: Project[] = [
  {
    id: 1,
    key: "joj2026",
    image: "joj2026.png",
    skills: ["Python", "Pandas", "Scikit-learn", "Matplotlib", "Seaborn"],
    codeLink: "https://github.com/taphacoobams/dakarurbantraffic",
  },
  {
    id: 2,
    key: "burnoutCheck",
    image: "burnoutcheck.png",
    skills: ["Python", "FastAPI", "React", "XGBoost", "SHAP", "Docker", "PostgreSQL"],
    demoLink: "https://burnoutcheck.vercel.app",
    codeLink: "https://github.com/taphacoobams/burnoutcheck",
  },
  {
    id: 3,
    key: "socabeg",
    image: "socabeg.png",
    skills: ["React", "Tailwind CSS", "Node.js", "Express"],
    demoLink: "https://socabeg.com/",
  },
  {
    id: 4,
    key: "khalilCollection",
    image: "khalilcollection.png",
    skills: ["React", "Node.js", "Express", "Tailwind CSS"],
    demoLink: "https://khalilcollection.com/",
  },
  {
    id: 5,
    key: "noppalJaay",
    image: "noppaljaay.png",
    skills: ["Next.js", "WhatsApp API", "PostgreSQL"],
    demoLink: "https://noppaljaay.app/",
  },
  {
    id: 6,
    key: "magouGlow",
    image: "magouglow.png",
    skills: ["E-commerce", "UI/UX", "Stripe"],
    demoLink: "https://www.magouglow.shop/",
  },
  {
    id: 7,
    key: "sengeoMap",
    image: "sengeomap.png",
    skills: ["React", "Maps API", "Data viz"],
    demoLink: "https://sengeomap.vercel.app/",
  },
  {
    id: 8,
    key: "yoonExpress",
    image: "yoonexpress.png",
    skills: ["React", "Node.js", "Paiement", "Tailwind"],
    demoLink: "https://yoon-express.vercel.app/",
  },
  {
    id: 9,
    key: "rentyx",
    image: "rentyx.png",
    skills: ["Next.js", "Booking", "UI/UX"],
    demoLink: "https://rentyx.vercel.app/",
  },
];
